import { Reference, Serializable } from '@pitaman71/omniglot-introspect';

export let debugMode = false;

export abstract class BaseMutation extends Serializable {
    isPrime = false;
    prime() { this.isPrime = true; return this; }
    abstract clone(prev: Reference<this>): this;
    abstract isSumma(): boolean;
    abstract isClear(): boolean;
    prev: Reference<this> = new Reference();
    next: Reference<this> = new Reference();
}

export function *makeGenerator<ValueType>(... iterables: Iterable<ValueType>[]) {
    for(let iterable of iterables) {
        for(let item of iterable) {
            yield item;
        }
    }
}
